export { default } from './ChessPawn'
